import { useState, useCallback } from 'react';

export interface RecentItem {
  id: number;
  title: string;
  stageName?: string;
  stageColor?: string;
  viewedAt: number;
}

const STORAGE_KEY = 'valentine-recent-items';
const MAX_ITEMS = 10;

function loadItems(): RecentItem[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveItems(items: RecentItem[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function useRecentItems() {
  const [items, setItems] = useState<RecentItem[]>(loadItems);

  const recordView = useCallback((item: Omit<RecentItem, 'viewedAt'>) => {
    setItems(prev => {
      const filtered = prev.filter(i => i.id !== item.id);
      const next = [{ ...item, viewedAt: Date.now() }, ...filtered].slice(0, MAX_ITEMS);
      saveItems(next);
      return next;
    });
  }, []);

  const clearAll = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setItems([]);
  }, []);

  return { items, recordView, clearAll };
}
